<ng-container *ngIf="routerURL$ | async"></ng-container>

<ion-grid class="max-w-1336">
	<ion-row><p class="pb-10 Heading_S">{{ jobFairName.title }}</p></ion-row>
	<ion-row>
		<ion-col size="3">
			<!--
			><ion-button [routerLink]="['/app/jobfair']">back</ion-button> -->
			<ion-grid
				class="side-menu-wrapper"
				[class.schedule]="class === 'schedule'"
				[class.jobfair-announce]="class === 'jobfair-announce'"
				[class.jobfair-faq]="class === 'jobfair-faq'"
				[class.notification-data]="class === 'notification-data'"
				[class.participants]="class === 'participants'"
				[class.participatingcompanies]="class === 'participatingcompanies'"
				[class.schedule-event]="class === 'schedule-event'"
			>
				<ion-row
					class="sidemenu-item ion-activatable ripple-parent"
					(click)="viewupdate('participatingcompanies')"
					[class.active]="class === 'participatingcompanies'"
				>
					<ion-col class="Body_M background">
						&nbsp; 📌 Participating companies &nbsp;
					</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row>

				<ion-row
					class="sidemenu-item ion-activatable ripple-parent"
					(click)="viewupdate('schedule')"
					[class.active]="class === 'schedule'"
				>
					<ion-col class="Body_M background">&nbsp; 📌 Schedule</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row>

				<ion-row
					class="sidemenu-item ion-activatable ripple-parent"
					(click)="viewupdate('schedule-event')"
					[class.active]="class === 'schedule-event'"
				>
					<ion-col class="Body_M background">&nbsp; 📌 Networking slot</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row>

				<!-- <ion-row class="sidemenu-item ion-activatable ripple-parent" (click)="viewupdate('jobfair-announce')"
					[class.active]="class === 'jobfair-announce'">
					<ion-col class="Body_M background">📌 Jobfair Announce</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row> -->
				<ion-row
					class="sidemenu-item ion-activatable ripple-parent"
					(click)="viewupdate('jobfair-faq')"
					[class.active]="class === 'jobfair-faq'"
				>
					<ion-col class="Body_M background">&nbsp; 📌 Jobfair FAQs</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row>
				<!-- <ion-row class="sidemenu-item ion-activatable ripple-parent" (click)="viewupdate('notification-data')"
					[class.active]="class === 'notification-data'">
					<ion-col class="Body_M background">📌 Notification data</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row> -->
				<!-- <ion-row class="sidemenu-item ion-activatable ripple-parent" (click)="viewupdate('participants')"
					[class.active]="class === 'participants'">
					<ion-col class="Body_M background">📌 Participants</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row> -->
			</ion-grid>
		</ion-col>
		<ion-col size="9">
			<router-outlet></router-outlet>
		</ion-col>
	</ion-row>
</ion-grid>
